"use client";

import React, { useMemo } from 'react';
import { ProductCard as BaseProductCard } from '@org/ui';
import useFavorites from '@/hooks/useFavorites';
import { extractFavoriteData } from '@/lib/favorites';
import { useLanguage } from '@/lib/config/useLanguage';

/**
 * Обертка над ProductCard из @org/ui с интеграцией локальных хуков
 */
export default function ProductCard({ item, showPrices = true, showDiscount = true, className = "" }) {
    const { isFavorite, toggleFavorite, isHydrated } = useFavorites();
    const { langCode, currency, localizePath } = useLanguage();

    const favoriteData = useMemo(() => extractFavoriteData(item), [item]);

    // Локализуем путь для товаров
    const localizedItemPath = useMemo(() => {
        return localizePath('/shop/item');
    }, [localizePath]);

    return (
        <BaseProductCard
            item={item}
            langCode={langCode}
            currency={currency || undefined}
            itemPath={localizedItemPath}
            favoriteManager={favoriteData ? {
                isFavorite,
                toggleFavorite,
                isHydrated,
            } : undefined}
            favoriteDataExtractor={extractFavoriteData}
            showPrices={showPrices}
            showDiscount={showDiscount}
            className={className}
        />
    );
}
